import { Monitor, Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { type ThemeChoice, useTheme } from "@/theme";

const NEXT: Record<ThemeChoice, ThemeChoice> = {
  system: "light",
  light: "dark",
  dark: "system",
};

/** One button that cycles system → light → dark. */
export function ThemeToggle() {
  const { t } = useTranslation();
  const choice = useTheme((s) => s.choice);
  const setChoice = useTheme((s) => s.setChoice);
  const Icon = choice === "dark" ? Moon : choice === "light" ? Sun : Monitor;
  const label = t("theme.button", {
    current: t(`theme.${choice}`),
    next: t(`theme.${NEXT[choice]}`),
  });
  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label={label}
      title={label}
      onClick={() => setChoice(NEXT[choice])}
    >
      <Icon className="h-4 w-4" aria-hidden />
    </Button>
  );
}
